import * as R from "ramda";

import { HeaderOfficeInfo, OfficeInfoContainer } from "./styles";
import { Spacer } from "views/components/common/Spacer";
import Icon, { Icons } from "react-hp-icons";
import React from "react";
import Skeleton from "react-loading-skeleton";
import { Link } from "react-router-dom";
export const OfficeInfo = ({ office, logos }) => {
	const logo = R.pathOr(false, ["options", "brand", "logo"], office);
	const showLogo = R.pathOr(false, ["options", "brand", "show_logo"], office);

	return (
		<OfficeInfoContainer>
			<HeaderOfficeInfo>
				<Link to={`/offices/${office.slug}`}>
					<div className="office__info-img-container">
						<img
							src={
								showLogo
									? logo
									: logos[`logo_${office.category_id}_color`]
							}
						/>
					</div>
				</Link>
				<h4 className="officeName">{office.name}</h4>
			</HeaderOfficeInfo>
			<Spacer rows={1} />
			<div className="office__info-content">
				<Icon type={Icons.location} size={1.5} />
				<span>{office ? office.street : <Skeleton />}</span>
			</div>
			<Spacer rows={1} />
			<div className="office__info-content">
				<Icon type={Icons.calendar} size={1.5} />
				<span>{office ? hoursMessage(office) : <Skeleton />}</span>
			</div>
			<Spacer rows={1} />
			<div className="office__info-content">
				<Icon type={Icons.phone} size={1.5} />
				<span>{office ? office.phone : <Skeleton />}</span>
			</div>
		</OfficeInfoContainer>
	);
};
const hoursMessage = (office) =>
	R.pathOr(null, ["options", "hours_message"], office);
